import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/sede/Sede.vue'),
		meta: {
			title: 'sede',
			acl: 'section.sede'
		}
	}
];

export default routes;